<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import ClassInput from "@/components/design/class/ClassInput.vue";
import {NotFoundError, NotUniqueError} from "@/errors/errors";
import {DraftState, draftState, emptyIdea} from "@/utils/modelUtils";
import IdeaLevelRouteComponent from "@/components/shared/IdeaLevelRouteComponent";
import {deepCopy} from "@/utils/copy";

@Component({emits: ['reloadNav'], components: {'ontos-class-input': ClassInput}})
class EditClass extends IdeaLevelRouteComponent {
  ideaOnChange = emptyIdea()
  declare $refs: {input: InstanceType<typeof ClassInput>}

  async load() {
    try {
      this.ideaOnChange = deepCopy(this.idea) //copia e deixa reativa
    } catch (err) {
      if (err instanceof NotFoundError) await this.$router.push({name: 'home'})
      else this.throwError(this.$tt('error.load-collection', {name: this.$route.params.idea}), err)
    }
  }

  async save() {
    const input = this.$refs.input;
    try {
      if (input.validateModel()) {
        await this.updateCurrentIdea(this.edit.changes)
        this.info(this.$tt('info.collection-updated', {name: this.idea.name}))
        //this.$emit('reloadNav')
        await this.$router.push({name: 'view-idea', params: {...this.$route.params, idea: this.idea.alias}})
      }
    } catch (err) {
      if (err instanceof NotUniqueError) {
        this.$refs.input.notUnique(err.data.property as 'name' | 'pluralName' | 'alias')
      } else this.throwError(this.$tt('error.update-collection', {name: this.idea.name}), err)
    }
  }

  /** O que mudou e se o salvar habilita — a regra mora no `draftState` */
  get edit(): DraftState {
    return draftState(this.idea, this.ideaOnChange)
  }
}


export default toNative(EditClass)
</script>
<template>
  <ontos-base v-bind="baseProps" ref="base">
    <v-form ref="form" v-if="loaded">
      <ontos-page-header :title="$tt('collection-edit')"/>
      <v-row>
        <v-col cols="10">
          <ontos-class-input ref="input" :value="ideaOnChange" @input="ideaOnChange = $event" :ideas="workspace.ideas" fixed-alias/>        </v-col>
        <v-col align-self="center">
          <v-btn size="small" color="primary" @click="save()" :disabled="edit.unchanged">
            <v-icon start>mdi-content-save</v-icon>
            {{ $tt('save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </ontos-base>
</template>
